import { render, staticRenderFns } from "./EditTagsModal.vue?vue&type=template&id=a584f06c&scoped=true"
import script from "./EditTagsModal.vue?vue&type=script&lang=js"
export * from "./EditTagsModal.vue?vue&type=script&lang=js"
import style0 from "./EditTagsModal.vue?vue&type=style&index=0&id=a584f06c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a584f06c",
  null
  
)

export default component.exports